import { FC, ReactNode } from 'react';

interface PainelCardProps {
  titulo: string;
  subtitulo?: ReactNode;
  acoes?: ReactNode;
  children: ReactNode;
  testId?: string;
}

/** Moldura dos blocos do painel: título, subtítulo curto e ações à direita. */
const PainelCard: FC<PainelCardProps> = ({ titulo, subtitulo, acoes, children, testId }) => (
  <section
    data-testid={testId}
    className="bg-surface-card border border-theme-border rounded-xl p-5 flex flex-col gap-4 min-w-0"
  >
    <header className="flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <h2 className="text-content-primary font-semibold">{titulo}</h2>
        {subtitulo && <p className="text-content-muted text-xs mt-0.5">{subtitulo}</p>}
      </div>
      {acoes}
    </header>
    {children}
  </section>
);

export default PainelCard;
